import objectToList from "@/utils/object-to-list"

export default class FinancialService {

  static get PAYMENT_PERIOD() {
    return {
      daily: { 
        id: "daily",
        label: "Diário",
        description: "Diário", 
      },
      weekly: { 
        id: "weekly",
        label: "Semanal",
        description: "Semanal", 
      },
      biweekly: { 
        id: "biweekly",
        label: "Quinzenal",
        description: "Quinzenal", 
      },
      monthly: { 
        id: "monthly",
        label: "Mensal",
        description: "Mensal", 
      },
    }
  }

  static get PAYMENT_TYPE() {
    return {
      bank_slip: { 
        id: "bank_slip",
        icon: "barcode icon", 
        label: '<i class="barcode icon"></i> Boleto Bancário',
        description: "Boleto Bancário" 
      },      
      credit: { 
        id: "credit",
        icon: "credit card outline red icon", 
        label: '<i class="credit card outline red icon"></i> Cartão de Crédito',
        description: "Cartão de Crédito" 
      },
      debit: { 
        id: "debit",
        icon: "credit card blue icon", 
        label: '<i class="credit card blue icon"></i> Cartão de Débito',
        description: "Cartão de Débito" 
      },
      check: { 
        id: "check",
        icon: "money check alternate olive icon", 
        label: '<i class="money check alternate olive icon"></i> Cheque',
        description: "Cheque" 
      },
      money: { 
        id: "money",
        icon: "money bill alternate outline green icon", 
        label: '<i class="money bill alternate outline green icon"></i> Dinheiro',
        description: "Dinheiro" 
      },      
      transfer: { 
        id: "transfer",
        icon: "exchange alternate purple icon", 
        label: '<i class="exchange alternate purple icon"></i> Transferência Bancária',
        description: "Transferência Bancária" 
      },      
      waiting_transfer: {
        id: "waiting_transfer",
        icon: "clock outline pink icon", 
        label: '<i class="clock outline pink icon"></i> Aguardando Transferência Bancária',
        description: "Aguardando Transferência Bancária"
      },
      manual_input: {
        id: "manual_input",
        icon: "edit icon", 
        label: '<i class="edit icon"></i> Preenchimento manual',
        description: "Preenchimento manual"
      },
    }
  }

  static get PAYMENT_TO() {
    return {
      company: { 
        id: "company",
        label: "Simavet",
        description: "Simavet", 
      },
      employee: { 
        id: "employee",
        label: "Colaborador",
        description: "Colaborador", 
      },
    }
  }

  static getPaymentPeriodList() {    
    return objectToList(FinancialService.PAYMENT_PERIOD)
  }

  static getPaymentTypeList(options) {    

    if (!options)
      options = {}

    let hide = []
    
    if (options.hide && options.hide.length > 0)
      hide = options.hide

    const list = objectToList(FinancialService.PAYMENT_TYPE)    

    return list.filter((type) => hide.indexOf(type.id) == -1)
  }

  static getPaymentToList() {
    return objectToList(FinancialService.PAYMENT_TO)
  }

  static shouldIssueInvoice(cert, receivable) {

    let issuesInvoice = false

    if (receivable.paymentType == "bank_slip") {
      issuesInvoice = true
    } else if (receivable.paymentType == "money") {
      issuesInvoice = false
    } else {
      if (receivable.user) {
        issuesInvoice = (receivable.user.group == "admin")
      } else {
        issuesInvoice = cert.customer.issuesInvoice          
      }
    }

    return issuesInvoice
  }
}